import { useI18n } from 'next-localization';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { FC } from 'react';
import { ComponentProps } from 'lib/component-props';

const BackToTopButton: FC<{ className: string } & Partial<ComponentProps>> = ({
  className,
}): JSX.Element => {
  const { t } = useI18n();
  const toTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={`back-to-top button-wrapper ${className}`}>
      <AbrdnButton buttonType="textLink" onClick={toTop} className="bg-transparent">
        <span>{t('backToTop')}</span>
        <i className="bi bi-chevron-up ms-1 svg-image" aria-hidden="true" />
      </AbrdnButton>
    </div>
  );
};

export default BackToTopButton;
